import React from 'react';
import { CoachCard } from '../shared/CoachCard';
export const TechnicalTeamSection = () => {
  const coaches = [{
    name: 'Arash (Ari) Saif',
    role: 'Systems Design Expert',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a8f27ef708b31e95d7c_image-1.png',
    bio: 'Sr Principal Engineer at Oracle, PhD in Computer Engineering',
    specialties: ['System Design', 'Scalability', 'Cloud Architecture'],
    linkedin: 'https://www.linkedin.com/in/ourarash/'
  }, {
    name: 'Paul Kim',
    role: 'Technical Coach',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a904cf99329118c54f4_image-4.png',
    bio: 'Engineering Director; Ex-Amazon Engineering Manager with deep expertise in systems architecture, backend design, and startup hiring bars',
    specialties: ['Algorithms', 'Data Structures', 'Problem Solving'],
    linkedin: 'https://www.linkedin.com/in/paul-kim-software/'
  }, {
    name: 'Fnu Jimmy',
    role: 'Systems Design and Technical Interviewing Coach',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a9000fccd0710900fd5_image-3.png',
    bio: 'Principle MTS Engineer at Oracle, TA at Georgia Institute of Technology with almost 20 years of experience.',
    specialties: ['React', 'Performance', 'Architecture'],
    linkedin: 'https://www.linkedin.com/in/fnujimmy/'
  }, {
    name: 'Lei Shi',
    role: 'Systems Design and Technical Interviewing Coach',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/684166417332056056a28670_leishi.jpeg',
    bio: 'Lead Software Engineer at Meta, AI and Blockchain',
    specialties: ['Machine Learning', 'System Design', 'Platform and Devops'],
    linkedin: 'https://www.linkedin.com/in/shileiwill/'
  }, {
    name: 'Pierre Antoine',
    role: 'Cloud Architecture Expert',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a90531f3b925be09e89_image-2.png',
    bio: 'Principal Architect and Ex-JP Morgan Chase Senior VP Lead Software Engineer',
    specialties: ['Microservices', 'APIs', 'Database Design']
  }, {
    name: 'Jeff Jackson',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a907160c4896037ed9b_image.png',
    role: 'Data Structure and Algorithms Expert',
    bio: 'PhD Professor with 30 years of experience at Carnegie Mellon University and California State University.',
    linkedin: 'https://www.linkedin.com/in/jeff-jackson-2b976916/'
  }, {
    name: 'Karthik Gajulapalli',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/682e3a9053a7b36f3a37b79a_image-5.png',
    role: 'Technical Screens and Pair Programming Expert',
    bio: 'Competitive coding engineer, PhD Candidate at Georgetown University',
    linkedin: 'https://www.linkedin.com/in/kgajulapalli/',
    website: 'https://kgajulapalli.org/index.html'
  }, {
    name: 'John B Lent',
    image: 'https://cdn.prod.website-files.com/65dcdc8067ad38483fe3b6b4/6a1631ad3bfcfb5d751f6f12_1745898149793.jpeg',
    role: 'iOS System Design Expert',
    bio: 'Staff iOS Engineer at Apple, ex-Uber',
    specialties: ['iOS', 'Swift', 'System Design'],
    linkedin: 'https://www.linkedin.com/in/jbakerlent/'
  }];
  return <section className="w-full bg-gradient-to-br from-[#1a0d24] to-[#231232] py-24 border-t border-b border-[#6805DA]/20" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <h2 className="text-4xl font-outfit font-bold mb-6 text-white" data-id="element-216">
            Technical Coaching Team
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-217">
            Our specialized technical coaches ensure you're prepared for every
            aspect of the interview process.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-218">
          {coaches.map(coach => <CoachCard key={coach.name} {...coach} data-id="element-219" />)}
        </div>
      </div>
    </section>;
};